import Rest from "../../../class/tool/Rest"
import Dashboard from "./Dashboard"
import Sale from "../../_operation/Sale/Sale"
import moment from "moment"
import FormBuilder from "../../../class/tool/FormBuilder"
moment.locale("fr")

class DashboardController {
    #_rest = new Rest();
    _baseURL = "dashboard";
    _callback = null;
    _callbackBestCategories = null;
    _callbackBestProducts = null;
    _callbackBestSubcategories = null;
    _callbackCA = null;
    _callbackCategories = null;
    _callbackPayments = null;
    _callbackPricelists = null;
    _callbackProducts = null;
    _callbackSales = null;
    _callbackSalesStats = null;
    _callbackLightSalesStats = null;
    _callbackSubcategories = null;
    _callbackVats = null;
    _dateFormat = "DD-MM-YYYY";

    buildDateBounds(dates, toObject = false, compare = null, withVersus = true, withSubPeriods = true) {
        let params = toObject ? {} : "";
        const begin = dates.dates.begin;
        const end = dates.dates.end !== null ? dates.dates.end : begin;
        const vsBegin = withVersus ? dates.vsDates.begin : null;
        const vsEnd = withVersus ? (dates.vsDates.end !== null ? dates.vsDates.end : vsBegin) : null;

        if (toObject) {
            params.begin = moment(begin).format(this._dateFormat)
            params.end = moment(end).format(this._dateFormat)
        }
        else {
            params = "?period[begin]=" + moment(begin).format(this._dateFormat) + "&period[end]=" + moment(end).format(this._dateFormat);

            if (withVersus && vsBegin !== null && vsEnd !== null)
                params += "&versus[begin]=" + moment(vsBegin).format(this._dateFormat) + "&versus[end]=" + moment(vsEnd).format(this._dateFormat);

            if (withSubPeriods)
                params += "&subperiods";
        }

        return params;
    }
    buildFilters(filters) {
        let filter = "";

        if (filters.license_id !== undefined && filters.license_id !== null)
            filter += "filters[license_id][]=" + filters.license_id;

        if (filters.seller_id !== undefined && filters.seller_id !== null)
            filter += (filter.length > 0 ? "&" : "") + "filters[seller_id][]=" + filters.seller_id;

        return filter;
    }

    index(dates, filters = {}) {
        let params = this.buildDateBounds(dates, dates.toObject !== undefined ? dates.toObject : false, dates.compare !== undefined ? dates.compare : null, dates.withVersus !== undefined ? dates.withVersus : true, dates.withSubPeriods !== undefined ? dates.withSubPeriods : true)
        let filter = this.buildFilters(filters);
        let url = '/' + this._baseURL;
        url += params.replaceAll("/", "-");

        if (filter.length > 0)
            url += (params.length > 0 ? "&" : "?") + filter;

        this.#_rest.sendQuery(
            'GET',
            url,
            {},
            this.handleIndex)
    }
    handleIndex = (response, error, status = 200) => {
        const object = !error ? new Dashboard(response.data) : null;
        this._callback(object, error, status);
    }

    get(dashboard, attribute, page = null, nb = null, sorton = null, sortvalue = null, input = null) {
        const callbacks = {
            "bestCategories": this.handleGetBestCategories,
            "bestProducts": this.handleGetBestProducts,
            "bestSubcategories": this.handleGetBestSubcategories,
            "ca": this.handleGetCA,
            "categories": this.handleGetCategories,
            "payments": this.handleGetPayments,
            "pricelists": this.handleGetPricelists,
            "products": this.handleGetProducts,
            "sales": this.handleGetSales,
            "salesStats": this.handleGetSalesStats,
            "lightSalesStats": this.handleGetLightSalesStats,
            "subcategories": this.handleGetSubcategories,
            "vats": this.handleGetVats
        };
        const restService = new Rest();
        let path = Reflect.get(dashboard, attribute);

        let explode = decodeURI(path).split('?');
        let datas = {};

        path = explode[0];
        Rest.parse_str(explode[1], datas);

        if (attribute === "sales") {
            if (nb !== null)
                datas.nb = nb;

            if (page !== null)
                datas.page = page;

            if (sorton !== null && sortvalue !== null) {
                datas.sorton = sorton;
                datas.sortvalue = sortvalue;
            }

            if (input !== null && input !== "")
                datas.input = input;
        }

        restService.sendQuery(
            'POST',
            '/' + path,
            datas,
            callbacks[attribute]);
    }
    handleGetBestCategories = (response, error, status = 200) => {
        this._callbackBestCategories(response.data !== undefined ? response.data : {}, error, status);
    }
    handleGetBestProducts = (response, error, status = 200) => {
        this._callbackBestProducts(response.data !== undefined ? response.data : {}, error, status);
    }
    handleGetBestSubcategories = (response, error, status = 200) => {
        this._callbackBestSubcategories(response.data !== undefined ? response.data : {}, error, status);
    }
    handleGetCA = (response, error, status = 200) => {
        this._callbackCA(response.data !== undefined ? response.data : {}, error, status);
    }
    handleGetCategories = (response, error, status = 200) => {
        this._callbackCategories(response.data !== undefined ? response.data : {}, error, status);
    }
    handleGetPayments = (response, error, status = 200) => {
        this._callbackPayments(response.data !== undefined ? response.data : {}, error, status);
    }
    handleGetPricelists = (response, error, status = 200) => {
        this._callbackPricelists(response.data !== undefined ? response.data : {}, error, status);
    }
    handleGetProducts = (response, error, status = 200) => {
        this._callbackProducts(response.data !== undefined ? response.data : {}, error, status);
    }
    handleGetSales = (response, error, status = 200) => {
        let listObjects = [];
        let pagination = null;

        if(status === 200) {
            let data

            if (response.data !== undefined && response.data.data !== undefined) {
                if(response.data.total !== undefined) {
                    pagination = {
                        total: response.data.total,
                        from: response.data.from != null ? response.data.from : 0,
                        to: response.data.to != null ? response.data.to : 0,
                        per_page: response.data.per_page,
                        current_page: response.data.current_page,
                        first_page_url: new URL(response.data.first_page_url).search,
                        last_page_url: new URL(response.data.last_page_url).search,
                        next_page_url: response.data.next_page_url !== null ? new URL(response.data.next_page_url).search : null,
                        prev_page_url: response.data.prev_page_url !== null ? new URL(response.data.prev_page_url).search : null
                    }
                }

                data = response.data.data
            }
            else if (response.data)
                data = response.data

            for (let item in data)
                listObjects.push(new Sale(data[item]));
        }

        this._callbackSales(listObjects, error, pagination, status);
    }
    handleGetSalesStats = (response, error, status = 200) => {
        this._callbackSalesStats((response.data !== undefined && response.data.stats !== undefined) ? response.data.stats : {}, error, status);
    }
    handleGetLightSalesStats = (response, error, status = 200) => {
        this._callbackLightSalesStats((response.data !== undefined && response.data.stats !== undefined) ? response.data.stats : {}, error, status);
    }
    handleGetSubcategories = (response, error, status = 200) => {
        this._callbackSubcategories(response.data !== undefined ? response.data : {}, error, status);
    }
    handleGetVats = (response, error, status = 200) => {
        this._callbackVats(response.data !== undefined ? response.data : {}, error, status);
    }

    exportPosState(email, dates, emails, formats, consolidated = null, filters) {
        let datas = {}
        datas.period = this.buildDateBounds(dates, true, dates.compare !== undefined ? dates.compare : null, dates.withVersus !== undefined ? dates.withVersus : true, dates.withSubPeriods !== undefined ? dates.withSubPeriods : true);
        datas.filters = filters;
        datas.email = email.toLowerCase();
        datas.posState = formats;
        datas.oneByOne = true;

        if (consolidated !== null)
            datas.consolidated = consolidated;

        if (emails.length > 0)
            datas.otherEmails = emails;

        this.#_rest.sendQuery(
            'POST',
            '/' + this._baseURL + '/export',
            datas,
            this.handleExport);
    }
    exportSales(email, dates, emails, formats, filters) {
        let datas = {}
        datas.period = this.buildDateBounds(dates, true);
        datas.filters = filters;
        datas.email = email.toLowerCase();
        datas.sales = formats;

        if (emails.length > 0)
            datas.otherEmails = emails.join(',').toLowerCase();

        this.#_rest.sendQuery(
            'POST',
            '/' + this._baseURL + '/export',
            datas,
            this.handleExport)
    }
    exportSoldQuantities(email, dates, emails) {
        let datas = {}
        datas.period = this.buildDateBounds(dates, true)
        datas.email = email.toLowerCase();
        datas.soldQuantities = ["excel"];

        if (emails.length > 0)
            datas.otherEmails = emails.join(',').toLowerCase();

        this.#_rest.sendQuery(
            'POST',
            '/' + this._baseURL + '/export',
            datas,
            this.handleExport)
    }
    exportDrawerEvents(drawerId, email, emails) {
        let datas = {}
        datas.drawer_id = drawerId;
        datas.email = email.toLowerCase();

        if (emails.length > 0)
            datas.otherEmails = emails.join(',').toLowerCase();

        this.#_rest.sendQuery(
            'POST',
            '/drawerevententries/export',
            datas,
            this.handleExport)
    }
    handleExport = (response, error, status = 200) => {
        if (this._callback !== null)
            this._callback(response, error, status)
    }
}

export default DashboardController;
